export const MARKET_CHART_DAYS = 30;

export const MARKET_CHART_COLORS = [
  '#0948B3',
  '#F8BD7A',
  '#1B998B',
  '#404E7C',
  '#C83E4D',
  '#94A3B8',
  '#23d2d4',
  '#fd7f23',
  '#9751a1',
  '#b4ed29'
];

export function formatPct(value, decimals = 2) {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '—';
  }
  const prefix = value >= 0 ? '+' : '';
  return `${prefix}${value.toFixed(decimals)}%`;
}

export function formatDateRange(dates) {
  if (!dates || dates.length < 2) {
    return null;
  }
  return `${dates[0]} – ${dates[dates.length - 1]}`;
}

function parseMarketDate(dateStr) {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function rebaseSeriesFromIndex(seriesData, startIndex) {
  const baseValue = seriesData[startIndex];

  if (typeof baseValue !== 'number') {
    return seriesData.slice(startIndex);
  }

  return seriesData.slice(startIndex).map((value) => {
    if (typeof value !== 'number') {
      return value;
    }
    return ((1 + value / 100) / (1 + baseValue / 100) - 1) * 100;
  });
}

function fillChartValues(values) {
  let lastKnown = null;
  return values.map((value) => {
    const numericValue = Number(value);
    if (Number.isFinite(numericValue)) {
      lastKnown = numericValue;
      return numericValue;
    }
    return lastKnown ?? 0;
  });
}

export function normalizePortfolioChart(data) {
  const dates = Array.isArray(data?.dates) ? data.dates : [];
  const rawValues = Array.isArray(data?.values) ? data.values : [];
  return {
    dates,
    values: fillChartValues(rawValues)
  };
}

export function trimMarketData({ dates = [], series = [], days = MARKET_CHART_DAYS }) {
  if (!dates.length || days <= 0) {
    return { dates, series };
  }

  const endDate = parseMarketDate(dates[dates.length - 1]);
  const windowStart = new Date(endDate);
  windowStart.setDate(windowStart.getDate() - days);

  let startIndex = dates.findIndex((dateStr) => parseMarketDate(dateStr) >= windowStart);
  if (startIndex < 0) {
    startIndex = 0;
  }

  if (startIndex === 0) {
    return { dates, series };
  }

  const trimmedDates = dates.slice(startIndex);
  const trimmedSeries = (series || []).map((item) => ({
    ...item,
    data: rebaseSeriesFromIndex(item.data || [], startIndex)
  }));

  return { dates: trimmedDates, series: trimmedSeries };
}

export function getDayChange(seriesItem) {
  const data = seriesItem?.data || [];
  if (data.length < 2) {
    return null;
  }
  return data[data.length - 1] - data[data.length - 2];
}

export function buildSummaryRows(series) {
  return (series || []).map((item, index) => ({
    name: item.name,
    dayChange: getDayChange(item),
    color: MARKET_CHART_COLORS[index % MARKET_CHART_COLORS.length]
  }));
}
